import apiService from "../../ApiService";

export const deleteNotifications = (id: string) => {
  return apiService.post<unknown>({
    path: `v1/me/notifications/${id}`,
    requiresAuthPolicy: "user",
  });
};
